import { render, staticRenderFns } from "./default.vue?vue&type=template&id=496bcb1c&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=496bcb1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MaintenanceAlert: require('/builds/mytia/mege-educacional/components/MaintenanceAlert.vue').default,NavBar: require('/builds/mytia/mege-educacional/components/NavBar.vue').default,HeaderBar: require('/builds/mytia/mege-educacional/components/HeaderBar.vue').default,ClassModal: require('/builds/mytia/mege-educacional/components/ClassModal.vue').default,AppSuccessModal: require('/builds/mytia/mege-educacional/components/AppSuccessModal.vue').default})
